export type PinType = 'restaurant' | 'parking' | 'custom';

export const PIN_TYPES: { id: PinType; label: string }[] = [
  { id: 'restaurant', label: 'Restaurant' },
  { id: 'parking', label: 'Parking' },
  { id: 'custom', label: 'Autre' },
];

export const PIN_SVG: Record<PinType, string> = {
  restaurant: `<svg width="36" height="48" viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 0C8.06 0 0 8.06 0 18c0 13.5 18 30 18 30s18-16.5 18-30C36 8.06 27.94 0 18 0z" fill="#38531C"/>
    <circle cx="18" cy="18" r="6" fill="#F1F1EF"/>
  </svg>`,
  parking: `<svg width="36" height="48" viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 0C8.06 0 0 8.06 0 18c0 13.5 18 30 18 30s18-16.5 18-30C36 8.06 27.94 0 18 0z" fill="#6E6B5E"/>
    <circle cx="18" cy="18" r="8" fill="#F1F1EF"/>
    <text x="18" y="23" text-anchor="middle" font-family="Inter, system-ui, sans-serif" font-weight="700" font-size="14" fill="#6E6B5E">P</text>
  </svg>`,
  custom: `<svg width="36" height="48" viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 0C8.06 0 0 8.06 0 18c0 13.5 18 30 18 30s18-16.5 18-30C36 8.06 27.94 0 18 0z" fill="#76947C"/>
    <circle cx="18" cy="18" r="6" fill="#F1F1EF"/>
  </svg>`,
};

export interface MarkerData {
  lat: number;
  lng: number;
  label?: string;
  type?: PinType;
}
